import { render, staticRenderFns } from "./tabExternalProjectProcessMonitoring.vue?vue&type=template&id=0d9fb75c&scoped=true&"
import script from "./tabExternalProjectProcessMonitoring.vue?vue&type=script&lang=ts&"
export * from "./tabExternalProjectProcessMonitoring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9fb75c",
  null
  
)

export default component.exports